/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { Loader, Pagination, Table } from '../../../../../common/components';
import { PayOffReportTableColumns, reports } from '../../../../../utils/constant';
import DownloadModal from '../../../downloadModal/downloadModal';
import EmailModal from '../../../emailModal/emailModal';
import ItemEmptyTile from '../../../item-empty-tile/item-empty-tile';
import Toolbar from '../../../toolbar/toolbar';
import onDownloadClick from '../../onDownloadClickHandler';
import PayOffTableRow from './payOffTableRow';

const PayOffReportTable = ({
  onCheckClick,
  payOffTableData,
  setApplyFilters,
  applyFilters,
  onSearchClick,
  debounceApiCall,
  payload,
  loading,
  setSearchText,
  searchText,
  page,
  setPage,
  limit,
  setLimit,
}) => {
  const [tableData, setTableData] = useState([]);

  const [totalRecords, setTotalRecords] = useState(null);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  const LoaderComponent = () => {
    if (loading) {
      return <Loader />;
    }
    return <ItemEmptyTile />;
  };
  useEffect(() => {
    setTotalRecords(payOffTableData?.count);
    setTableData(payOffTableData?.tableData);
  }, [payOffTableData?.tableData, payOffTableData?.count]);
  useEffect(() => {
    if (applyFilters) {
      onSearchClick({ page, limit });
    }
  }, [page, limit, onSearchClick, applyFilters]);
  const toggleEmailModal = () => {
    if (tableData?.length) {
      setIsEmailModalOpen(!isEmailModalOpen);
    }
  };

  const toggleDownloadModal = () => {
    if (tableData?.length) {
      setIsDownloadModalOpen(!isDownloadModalOpen);
    }
  };
  const onSerchInputChange = (event) => {
    const {
      target: { value },
    } = event;
    setSearchText(value);
    debounceApiCall(value);
  };

  return (
    <>
      <Toolbar
        title="Pay Off Report"
        optionOneLabel="Email Report"
        optionOneIcon="MdOutlineEmail"
        onOptionOneClick={toggleEmailModal}
        optionTwoLabel="Download Report"
        optionTwoIcon="FiDownload"
        setSearchText={setSearchText}
        onOptionTwoClick={toggleDownloadModal}
        searchText={searchText}
        onSerchInputChange={onSerchInputChange}
        isSearchable
        isTableDataPresent={tableData?.length > 0}
        SearchInputPlaceholder="OPI, Contract Number"
      />
      {tableData && tableData?.length > 0 ? (
        <>
          <div className="table-resp-scroll">
            <Table
              headers={PayOffReportTableColumns}
              bordered
              responsive
              className="dashboard-table pay-off-table"
            >
              <tbody>
                {tableData?.map((rowData, rowNumber) => (
                  <PayOffTableRow
                    key={rowNumber}
                    onCheckClick={onCheckClick}
                    rowData={rowData}
                    id={rowNumber}
                  />
                ))}
              </tbody>
            </Table>
            {loading && <Loader />}
          </div>

          <div className="pagination-araging-report">
            <Pagination
              totalResults={totalRecords}
              page={page}
              limit={limit}
              setPage={(pageNo) => {
                setApplyFilters(true);
                setPage(pageNo);
              }}
              setLimit={(rowlimit) => {
                setApplyFilters(true);
                setLimit(rowlimit);
              }}
            />
          </div>
        </>
      ) : (
        <div className="loader-empty">
          <LoaderComponent />
        </div>
      )}

      <EmailModal
        isOpen={isEmailModalOpen}
        toggle={toggleEmailModal}
        reportType={reports?.PAY_OFF_REPORT}
        apiValues={{
          locationId: payload?.locationId,
          purchaserName: payload?.purchaserName,
          contractNumber: payload?.contractNumber,
          purchaserOPI: payload?.purchaserOPI,
          ...(searchText && { opiOrName: searchText }),
        }}
        newFilters
      />
      <DownloadModal
        isOpen={isDownloadModalOpen}
        toggle={toggleDownloadModal}
        reportType={reports?.PAY_OFF_REPORT}
        urlParams={{
          ...payload,
          page,
          limit: 200,
          action: 'download',
          opiOrName: searchText,
        }}
        onDownloadClick={onDownloadClick}
        willReceiveReportFileInEmail
        newFilters
      />
    </>
  );
};
export default PayOffReportTable;
